module.exports = __webpack_public_path__ + "static/img/img-install-tag-truck.9325473.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/install-guide/img-install-tag-truck.svg
// module id = 1795
// module chunks = 1